var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l2lCompBigBox"},[_vm._v("l2lCompBigBox")])
}
var staticRenderFns = []

export { render, staticRenderFns }